import {Component, inject} from '@angular/core'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {LogoComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {ConfigService} from '../../services/config.service'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatMenu, MatMenuItem, MatMenuTrigger, LogoComponent, MatIcon, MatIconButton]
})
export class HeaderComponent {
  public service = inject(ConfigService)
}
